import { ElementProps } from '@/components/sections/builder/types';

import {
  FooterPaymentChannels,
  FooterSectionPaymentChannelsType,
} from '@/components/sections/builder/elements/footer/footer/types';

import { useBuilderStore } from '@/stores/builder';
import { BetweenHorizontalStart } from 'lucide-react';
import React from 'react';
import { shallow } from 'zustand/shallow';
import TextEditorMinimal from '@/components/commons/minimal-tiptap/minimal-editor';
import { useQuery } from '@tanstack/react-query';
import { retrievePaymentChannelsInfo } from '@/lib/actions/home/action';
import InputSelect from '@/components/sections/builder/settings/input-select';
import { cn } from '@/lib/utils';
import Image from 'next/image';

const defaultData: FooterSectionPaymentChannelsType = {
  name: 'Payment Channels',
  heading: 'Payment Channels',
  stylePaymentChannels: 'normal',
};

export const ElementContent = ({ element }: ElementProps) => {
  const { data } = useQuery({
    queryKey: ['payment-channels'],
    queryFn: async () => {
      const data = await retrievePaymentChannelsInfo();
      return data?.data;
    },
  });
  const content = (element.data || defaultData) as FooterSectionPaymentChannelsType;

  const paymentChannels = (data as FooterPaymentChannels[]) || [];

  return (
    <>
      <div className='h-full w-full'>
        <h2
          className='content-footer-text mb-1 text-lg font-medium'
          dangerouslySetInnerHTML={{ __html: content.heading || '' }}
        ></h2>
        <div className='flex flex-wrap gap-3 '>
          {paymentChannels.map((channel) => (
            <div
              className={cn(
                ' relative aspect-video h-6 ',
                content.stylePaymentChannels !== 'normal' && 'grayscale'
              )}
              key={channel.provider_channel_id}
            >
              <Image
                src={channel.logo_url}
                alt={channel.channel_name}
                fill
                className='object-contain'
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export const ElementPreviewIcon = BetweenHorizontalStart;

export function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as FooterSectionPaymentChannelsType;

  return (
    <div>
      <div className='mb-3'>
        <h3 className='mb-2 text-xs font-bold'>Heading</h3>
        <TextEditorMinimal
          value={data.heading as string}
          onChange={(val) => {
            builder.setChildData(element.parentId as string, element.id, {
              heading: val,
            });
          }}
          output='html'
          editorProps={{
            attributes: {
              class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
            },
          }}
          editable
        />
      </div>
      <div className='mb-3 grid grid-cols-2 items-center gap-2'>
        <h4 className=''>Payment Channels Style</h4>
        <InputSelect
          defaultValue={data.stylePaymentChannels}
          options={[
            { label: 'Normal', value: 'normal' },
            { label: 'Monochrome', value: 'monochrome' },
          ]}
          onChange={(v) =>
            builder.setChildData(element.parentId as string, element.id, {
              stylePaymentChannels: v,
            })
          }
        />
      </div>
    </div>
  );
}

const FooterSectionPaymentChannels = {
  type: 'footer_section_payment_channels',
  group: 'footer_section',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default FooterSectionPaymentChannels;
